<div class="list-group">
    <div
            *ngFor="let count of widgetData.content"
            class="list-group-item"
    >
		<span class="d-flex justify-content-between align-items-center">
			<b> {{ count.contract_status }}: </b>
            {{ count.contract_count }}
		</span>
    </div>
</div>
